import { createReducer, createActions } from 'reduxsauce';
import {
  LAYOUT_TYPE_FULL,
  THEME_COLOR_SELECTION_PRESET,
  THEME_TYPE_SEMI_DARK,
  NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
} from "../../constants/ThemeSetting";

const { Types, Creators } = createActions({
	toggleCollapsedSideNav: ['navCollapsed'],
	updateWindowWidth: ['width'],
	setThemeType: ['themeType'],
	setThemeColorSelection: ['colorSelection'],
	onNavStyleChange: ['navStyle'],
	onLayoutTypeChange: ['layoutType'],
  switchLanguage: ['locale'],
});

export const INITIAL_STATE = {
	navCollapsed: true,
  navStyle: NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
  layoutType: LAYOUT_TYPE_FULL,
  themeType: THEME_TYPE_SEMI_DARK,
  colorSelection: THEME_COLOR_SELECTION_PRESET,
  pathname: '',
  width: window.innerWidth,
  isDirectionRTL: false,
  locale: {
    languageId: 'spanish',
    locale: 'es',
    name: 'Spanish',
    icon: 'es'
  }
};

export const SettingsTypes = Types;
export default Creators;

const toggleCollapsedSideNav = (state, { navCollapsed }) => ({...state, navCollapsed });

const updateWindowWidth = (state, { width }) => ({...state, width });

const setThemeType = (state, { themeType }) => ({...state, themeType });

const onNavStyleChange = (state, { navStyle }) => ({...state, navStyle });

const setThemeColorSelection = (state, { colorSelection }) => ({...state, colorSelection });

const switchLanguage = (state, { locale }) => ({...state, locale });

const onLayoutTypeChange = (state, { layoutType }) => ({...state, layoutType });

export const reducer = createReducer(INITIAL_STATE, {
	[Types.TOGGLE_COLLAPSED_SIDE_NAV]: toggleCollapsedSideNav,
	[Types.UPDATE_WINDOW_WIDTH]: updateWindowWidth,
	[Types.SET_THEME_TYPE]: setThemeType,
	[Types.SET_THEME_COLOR_SELECTION]: setThemeColorSelection,
	[Types.ON_NAV_STYLE_CHANGE]: onNavStyleChange,
	[Types.ON_LAYOUT_TYPE_CHANGE]: onLayoutTypeChange,
	[Types.SWITCH_LANGUAGE]:	switchLanguage,
});